import { render, staticRenderFns } from "./CompetitionForm.vue?vue&type=template&id=0c30378e&"
import script from "./CompetitionForm.vue?vue&type=script&lang=js&"
export * from "./CompetitionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports